import * as React from 'react';

import { clsx } from 'clsx';
import styles from './HowItWorks.css';

export const HowItWorks: React.FC<React.PropsWithChildren<{ title: string; isCenteredTitle: boolean }>> = ({
  title,
  children,
  isCenteredTitle,
}) => {
  return (
    <div className={styles['how-it-works']}>
      <h2 className={clsx(styles['title'], isCenteredTitle && styles['centered-title'])}>{title}</h2>

      <div className={styles['container']}>
        {React.Children.map(children, (child: React.ReactNode, index: number) => (
          <div className={styles['item']} key={index}>
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};
